import React, { useEffect, useState } from "react";
import Alpine from "alpinejs";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { useStoreLocalization } from "@src/hooks/useStoreLocalization";
import helpers from "@src/../js/helpers";
import useHeaderMenuStore from "@src/stores/HeaderMenuStore";
import useCurrencyForm from "@src/hooks/useCurrencyForm";
import currency from "../../../../../js/alpine/stores/currency";

export function HeaderMobileMenuCurrency({ settings }) {
    const linksStyle = 'h4';
    const useCurrencySelector = true;
    const { isLoading, error, success, enabledCurrencies, fetchCountries } = useStoreLocalization();
    const { submitCurrencyForm } = useCurrencyForm();
    const currencyCountry = helpers.getCookie("localization");
    const [selectedCurrency, setSelectedCurrency] = useState(currencyCountry);

    const { blocks, section } = settings;
    // Access the current menu state from the global store
    const { currentMenu } = useHeaderMenuStore();

    const handleCurrencyChange = (isoCode) => {
        setSelectedCurrency(isoCode);
        submitCurrencyForm(isoCode);
    };

    // State to toggle the currency selection menu
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        fetchCountries();
    }, []);

    const [currencyCode, setCurrencyCode] = useState('');
    useEffect(() => {
        window.addEventListener('currency_initialised' , (event) => {
            setCurrencyCode(event.detail.currency.name);
        });
    }, []);

    const currencyBlock = blocks?.find(block => block.type === "currency_selector");

    return (
        <>
            {section.show_currency_in_header && useCurrencySelector &&
                <div
                    className="mobile-menu-item flex flex-col py-[16px] gap-8"
                    onClick={() => setIsOpen((prev) => !prev)} // Toggle isOpen state
                >
                    {/* Clicking this div toggles the currency selector menu */}
                    <div className="flex justify-between items-center">
                        <span className={`${linksStyle} cursor-pointer`}>
                            {currencyCode}
                        </span>
                        {currencyBlock?.settings.show_currency_in_header_no_dropdown && <i
                            className={`icon-arrow-right mobile-menu__icon transition-transform duration-200 origin-center ${
                                isOpen ? "rotate-90" : "rotate-0"
                            }`}
                        ></i>}
                    </div>
                    {currencyBlock?.settings.show_currency_in_header_no_dropdown && <div className={`${!isOpen ? "hidden" : ""} ${linksStyle} cursor-pointer`}>
                        <form
                            className="currency-selector__form--mobile h4"
                            id="currency-form"
                            action="/localization"
                            method="post"
                        >
                            {(() => {
                                const renderedNames = new Set();

                                return enabledCurrencies.map((currency, index)  => {
                                    if (renderedNames.has(currency.name)) {
                                        return null;
                                    }

                                    renderedNames.add(currency.name);

                                    return (
                                        <label
                                            key={index}
                                            className={`currency-selector__form-label ${
                                                selectedCurrency === currency.code ? "selected" : ""
                                            }`}
                                        >
                                            <input type="hidden" name="form_type" value="localization" />
                                            <input type="hidden" name="utf8" value="✓" />
                                            <input type="hidden" name="_method" value="put" />
                                            <input type="hidden" name="return_to" value="/" />
                                            <input
                                                type="radio"
                                                name="country_code"
                                                value={currency.code}
                                                defaultChecked={selectedCurrency === currency.code}
                                                onClick={() => handleCurrencyChange(currency.code)}
                                                className="currency-selector__form-input"
                                            />
                                            {currency.name}
                                        </label>
                                    );
                                });
                            })()}
                        </form>
                    </div>}
                </div>
            }
        </>
    );
}
